import React, { ReactNode } from 'react';
interface ProfileSectionProps {
  title: string;
  children: ReactNode;
}
const ProfileSection: React.FC<ProfileSectionProps> = ({
  title,
  children
}) => {
  return <div className="space-y-4">
      
      <div>{children}</div>
    </div>;
};
export default ProfileSection;